import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { GetEmployeesListPayload } from "../../payload/GetEmployeesList/GetEmployeesListPayload";

const getEmployeesListFetch = (state: EmployeesState, action: PayloadAction<GetEmployeesListPayload>) => {
    state.isLoading = true;
}

export default getEmployeesListFetch;